module.exports = __webpack_public_path__ + "static/media/portrait2.01c42aae.jpg";